import React from 'react';
import { BankLogo, BankLogoProps } from './bank-logo';
import { Box, Tooltip, Typography } from '@mui/material';

export const BankLogoDetails = (
    props: BankLogoProps & {
        fontWeight?: number;
        fontSize?: number | string;
        fontFamily?: string;
    },
) => {
    const { iban, bankName, fontSize = '14px', fontWeight, fontFamily } = props;
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={iban ? bankName : ''}>
                <span>
                    <BankLogo {...props} />
                </span>
            </Tooltip>
            <Typography sx={{ ml: 1, fontWeight, fontSize, fontFamily }}>
                {iban ?? bankName}
            </Typography>
        </Box>
    );
};
